import request from '@/utils/request'
// 我的页面
export function my(data) {
    return request({
        url: '/admin/Webapi/my',
        method: 'POST',
        data: data || {}
    })
}
// 我的小组页面
export function index(data) {
    return request({
        url: '/api/table/index',
        method: 'POST',
        data: data || {}
    })
}
// 获取表格列表
export function tablelist(data) {
    return request({
        url: '/api/table/tablelist',
        method: 'POST',
        data: data || {}
    })
}
// 我的账户页面
export function myaccount(data) {
    return request({
        url: '/admin/Share/myaccount',
        method: 'POST',
        data: data || {}
    })
}
// 提现
export function transfers(data) {
    return request({
        url: '/admin/Share/transfers',
        method: 'POST',
        data: data || {}
    })
}
// 我的邀请页面
export function myshare(data) {
    return request({
        url: '/admin/Share/myshare',
        method: 'POST',
        data: data || {}
    })
}
// 达成成就
export function achievement(data) {
    return request({
        url: '/admin/Webapi/achievement',
        method: 'POST',
        data: data || {}
    })
}
// 我的证书
export function get_tactic_card(data) {
    return request({
        url: '/api/index/get_tactic_card',
        method: 'POST',
        data: data || {}
    })
}
// 用户提交表单
export function subtable(data) {
    return request({
        url: '/api/table/subtable',
        method: 'POST',
        data: data || {}
    })
}
// 我的课程列表
export function mc_list(data) {
    return request({
        url: '/api/mc/list',
        method: 'POST',
        data: data || {}
    })
}
// 我的课程订单详情
export function mc_orderDetail(data) {
    return request({
        url: '/api/mc/orderDetail',
        method: 'POST',
        data: data || {}
    })
}
// 我的课程支付调取
export function mc_buyCourse(data) {
    return request({
        url: '/api/mc/buyCourse',
        method: 'POST',
        data: data || {}
    })
}
// 订单列表点击去上课
export function mc_goToClass(data) {
    return request({
        url: '/api/mc/goToClass',
        method: 'POST',
        data: data || {}
    })
}
// 订单列表删除订单
export function mc_delOrder(data) {
    return request({
        url: '/api/mc/delOrder',
        method: 'POST',
        data: data || {}
    })
}
// 调整期次
export function mc_getSwaps(data) {
    return request({
        url: '/api/mc/getSwaps',
        method: 'POST',
        data: data || {}
    })
}
// 设定期次
export function mc_setSwaps(data) {
    return request({
        url: '/api/mc/setSwaps',
        method: 'POST',
        data: data || {}
    })
}
// 退款信息
export function mc_refund(data) {
    return request({
        url: '/api/mc/refund',
        method: 'POST',
        data: data || {}
    })
}
// 退款详情
export function mc_getRefund(data) {
    return request({
        url: '/api/mc/getRefund',
        method: 'POST',
        data: data || {}
    })
}
// 退款提交
export function mc_submitRefund(data) {
    return request({
        url: '/api/mc/submitRefund',
        method: 'POST',
        data: data || {}
    })
}
// 取消退款
export function mc_delRefund(data) {
    return request({
        url: '/api/mc/delRefund',
        method: 'POST',
        data: data || {}
    })
}
// 推广中心
export function promotionList(data) {
    return request({
        url: '/api/shareactivity/promotionList',
        method: 'POST',
        data: data || {}
    })
}
// 推广邀请列表
export function promotionIdList(data) {
    return request({
        url: '/api/shareactivity/promotionIdList',
        method: 'POST',
        data: data || {}
    })
}